export default "__VITE_ASSET__CCwqs34L__"